module.exports = __webpack_public_path__ + "assets/images/project/cover/cover-big.png?v=6fae2e14";